import { nonUndefined } from "Utility";
import { RoundTime } from "./RoundTime";
import { MatchmakingRound } from "../Set/Matchmaking/Track/MatchmakingRound";
import { WorldTourRound } from "../Set/WorldTour/Track/WorldTourRound";
import { isDnf } from "../DriverTime";

export type TrackRound = {
  golden?: boolean;
  times: RoundTime[];
};

export type TrackBasedTrackRound = MatchmakingRound | WorldTourRound;

export const roundIncludesDriver = (round: TrackRound, driverId: string) => {
  return !!round.times.find((t) => t.driverId === driverId);
};

export const getRoundLastPos = (round: TrackRound) => {
  if (round.times.length === 0) {
    return undefined;
  }

  return Math.max(...round.times.map((t) => t.position));
};

export const getDriverTimesWithLastPos = (
  rounds: TrackRound[],
  driverId: string
) => {
  return nonUndefined(
    rounds.map((r) => {
      const time = r.times.find((t) => t.driverId === driverId);
      const lastPos = getRoundLastPos(r);
      if (!time || !lastPos) {
        return undefined;
      }

      return {
        time,
        lastPos,
      };
    })
  );
};

export const getAllRoundTimes = (rounds: TrackRound[]) => {
  return nonUndefined(rounds.flatMap((r) => r.times ?? []));
};

export const roundTeamHasAce = (
  round: TrackBasedTrackRound,
  rosterDriverIds: string[]
) => {
  const rosterDriverTimes = round.times.filter((time) =>
    rosterDriverIds.includes(time.driverId)
  );

  const otherDriverTimes = round.times.filter(
    (time) => !rosterDriverIds.includes(time.driverId)
  );

  // Single drivers can't ace
  if (otherDriverTimes.length <= 1 || rosterDriverTimes.length <= 1) {
    return false;
  }

  // If only roster finished ACE by default
  if (otherDriverTimes.every(isDnf)) {
    return true;
  }

  // Other roster has at least one finish time, so if roster DNF worst than other best always
  const worstRosterDriverPosition = Math.max(
    ...rosterDriverTimes.map((time) => time.position)
  );

  // Other roster has at least one finish time, so their best always better than DNF
  const bestOtherDriverPosition = Math.min(
    ...otherDriverTimes.map((time) => time.position)
  );

  return worstRosterDriverPosition < bestOtherDriverPosition;
};
